// Shared "visible text" definition for pitch surfaces (counter, AI detection, previews).
// Tags become spaces so block boundaries don't glue words ("<li>a</li><li>b" -> "a b"),
// then entities decode — the textarea trick is safe because no tags remain.

const decodeEntities = (text) => {
  const el = document.createElement('textarea');
  el.innerHTML = text;
  return el.value;
};

const stripHtmlToVisibleText = (html) => decodeEntities(String(html || '').replace(/<[^>]*>/g, ' '))
  .replace(/\s+/g, ' ')
  .replace(/ ([,.;:!?])/g, '$1')
  .trim();

export default stripHtmlToVisibleText;
